import { useMutation } from "react-query";
import api from "../../utils/api";

export default function usePut(url) {
  return useMutation((payload) => api.put(url, payload));
}
